import { createI18n } from 'vue-i18n';
import activityMessages from './activityMessages';
export default createI18n({
    locale: 'en',
    messages: activityMessages,
    silentFallbackWarn: true
});
